import axios from 'axios';

export default class AuthService {
  userAuthenticated() {
    const user = this.getUser();
    return !!(user && user.sessionId);
  }

  deauthenticateUser() {
    const user = this.getUser();
    const idToken = user ? user.idToken : null;

    localStorage.removeItem('user');
    localStorage.removeItem('userToken');
    localStorage.removeItem('isFsid');

    // Hydra requires id_token_hint whenever post_logout_redirect_uri is set,
    // per the OIDC RP-Initiated Logout spec - Cognito's logout endpoint never
    // enforced this, so it went unnoticed until the switch to Hydra.
    const logoutUrl = idToken
      ? `${process.env.REACT_APP_FSID_LOGOUT_URL}&id_token_hint=${encodeURIComponent(idToken)}`
      : process.env.REACT_APP_FSID_LOGOUT_URL;

    window.open(logoutUrl, '_self');
  }

  setUser(User) {
    localStorage.setItem('user', User);
  }

  getUser() {
    return JSON.parse(localStorage.getItem('user'));
  }

  exchangeToken(code) {
    var url = `${process.env.REACT_APP_API_URL}/session/getToken`;
    var data = `code=${code}&redirect=${process.env.REACT_APP_INPERSON_URL}`;
    var config = {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      withCredentials: true
    };

    return axios
      .post(url, data, config)
      .then(response => {
        return response.data;
      })
      .then(userData => {
        var user = JSON.stringify(userData.user);
        if (userData.user.sessionId) {
          this.setUser(user);
        }
        return userData;
      })
      .catch(e => {
        if (e.response && e.response.status === 409 && e.response.data && e.response.data.redirectUrl) {
          window.location.assign(e.response.data.redirectUrl);
          return;
        }
        console.log('error', e);
      });
  }

  startSessionPoller(sessionId) {
    window.FormstackId.SessionPoller.setOptions({
      server: process.env.REACT_APP_FSID_URL,
      sid: sessionId,
      frequency: 10,
      onSessionExpired: this.deauthenticateUser
    });

    window.FormstackId.SessionPoller.start();
  }

  refreshUserCredentials() {
    const user = this.getUser();
    return new Promise((resolve, reject) => {
      if (user) {
        this.startSessionPoller(user.sessionId);

        window.FormstackId.SessionPoller.checkInGoodStanding().then(function(
          good
        ) {
          if (good) {
            resolve(user);
          } else {
            reject(false);
          }
        });
      } else {
        reject(false);
      }
    }).catch(e => {
      console.log(e);
    });
  }
}



// WEBPACK FOOTER //
// ./src/AuthService.js